import {Add} from 'components/grid-dx/consult-buttons/index';
import {Column} from 'devextreme-react/data-grid';
import {useGetAssistants} from 'features/instance-manager/hooks';
import useLoadCollaboratorPUT from 'features/instance-manager/hooks/useLoadCollaboratorPUT';
import {useLoadProfCollaborator} from 'features/profCollaborator/hooks';
import React from 'react';
import IntegrityRoleGrid from '../../../../components/UserRole';
import {i18n2} from '../../../i18n/i18n';
import {ADD_COLLABORATOR} from '../../types/types';
import {CollaboAssistantSchema} from '../../assistants/model/Collaborator';
import {ProfCollaborator} from '../../assistants/model/ProfCollaborator';
import {getActionColumnWidth} from 'components/grid-dx/styles/actionButtonStyles';
import {useIsTablet} from 'components/hooks/useIsTablet';

interface AssistantGridProps {
  role: string;
  useSpac: boolean;
  iD_Instance: number;
  iD_Course: number;
}
const MAX_ACTION_BUTTONS = 1;

const Buttons = ({data}: any) => {
  const assistants = useGetAssistants();
  let hidden: boolean = false;
  if (assistants.length > 0) {
    hidden = assistants.find((x: any) => x.employee_Nr === data.employee_Nr);
  }
  return !hidden ? <Add row={data} type={ADD_COLLABORATOR} /> : null;
};

const AssistantGrid = ({
  role,
  useSpac,
  iD_Instance,
  iD_Course,
}: AssistantGridProps) => {
  const isTablet = useIsTablet();
  const loadParam = JSON.stringify({
    Key: 'AddInstance',
    Value: iD_Instance,
    id_course: iD_Course,
  });
  const loadCollaborator = useLoadCollaboratorPUT(
    iD_Instance,
    iD_Course,
    false,
  );

  const loadProfCollaborator = useLoadProfCollaborator(loadParam);

  return (
    <IntegrityRoleGrid
      allowActions={false}
      allowIntegrity={false}
      hideToolbar
      height={'35vh'}
      shouldSaveFilters={true}
      id={useSpac ? ['employee_Nr', 'iD_ProfileSpac'] : ['employee_Nr']}
      schema={useSpac ? ProfCollaborator(false) : CollaboAssistantSchema(false)}
      dataSource={useSpac ? loadProfCollaborator : loadCollaborator}
      marginBottom="1vh">
      <Column caption={i18n2._('Nombre')} dataField="name" width={200} />
      <Column caption={i18n2._('CWID')} dataField="cwid" />
      {!useSpac ? (
        <Column
          caption={i18n2._('#Sector')}
          dataField="iD_Sector"
          visible={false}
        />
      ) : null}
      {!useSpac ? (
        <Column
          caption={i18n2._('#Perfil')}
          dataField="iD_Profile_Web"
          visible={false}
        />
      ) : null}
      {!useSpac ? (
        <Column
          caption={i18n2._('#Turno')}
          dataField="iD_Shift"
          visible={false}
        />
      ) : (
        <Column
          caption={i18n2._('Descripcion del SPAC')}
          dataField="profileDesc"
        />
      )}
      <Column caption={i18n2._('Sector')} dataField="sector_Name" />
      <Column caption={i18n2._('Perfil')} dataField="profile_Name" />
      <Column caption={i18n2._('Turno')} dataField="shift_Name" />
      <Column caption={i18n2._('Numero de empleado')} dataField="employee_Nr" />
      <Column
        caption=""
        cellComponent={(e: any) => <Buttons data={e.data.data} />}
        width={getActionColumnWidth(MAX_ACTION_BUTTONS, isTablet)}
        fixed
        alignment="right"
      />
    </IntegrityRoleGrid>
  );
};

export default AssistantGrid;
